import { format, parseISO } from "date-fns";

const TimeLogStatus = ({ status }) => {
  const statusStyles = {
    approved: "bg-green-100 text-green-800",
    rejected: "bg-red-100 text-red-800",
    pending: "bg-yellow-100 text-yellow-800",
  };

  return (
    <span
      className={`px-3 py-1 pb-4 rounded-full text-xs font-medium status-pill ${statusStyles[status]} flex justify-center items-center`}
    >
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );
};

const StudentTimeLogsDetailsPdf = ({
  studentTimeLogs,
  studentOpportunities,
  student,
}) => {
  const calculateHours = (startTime, endTime) => {
    const [startHour, startMinute] = startTime.split(":").map(Number);
    const [endHour, endMinute] = endTime.split(":").map(Number);

    const totalMinutes =
      endHour * 60 + endMinute - (startHour * 60 + startMinute);
    return totalMinutes / 60;
  };

  const calculateTotalApprovedHours = (logs) => {
    const total = logs
      .filter((log) => log.status === "approved")
      .reduce((sum, log) => {
        const hours = calculateHours(log.startTime, log.endTime);
        return sum + hours;
      }, 0);

    return Number(total.toFixed(1));
  };

  const renderOpportunityTimeLogs = (opportunity) => {
    const opportunityLogs = studentTimeLogs.filter(
      (log) =>
        log.opportunityId === opportunity.id &&
        log.studentId === student.studentId
    );

    const totalApprovedHours = opportunityLogs
      .filter((log) => log.status === "approved")
      .reduce(
        (sum, log) => sum + calculateHours(log.startTime, log.endTime),
        0
      );

    return (
      <div key={opportunity.id} style={{ marginBottom: '20px' }}>
        <h4 style={{ marginBottom: '10px' }}>
          <strong>{opportunity.hostName}</strong> ({opportunity.opportunityType})
        </h4>
        {opportunityLogs.length > 0 ? (
          <>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '10px' }}>
              <thead>
                <tr>
                  <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Date</th>
                  <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Time</th>
                  <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Hours</th>
                  <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {opportunityLogs.map((log, index) => (
                  <tr key={index}>
                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                      {format(parseISO(log.date), "MMM dd, yyyy")}
                    </td>
                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                      {log.startTime} - {log.endTime}
                    </td>
                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                      {calculateHours(log.startTime, log.endTime).toFixed(1)}
                    </td>
                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                      {log.status.charAt(0).toUpperCase() + log.status.slice(1)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p style={{ marginTop: '5px' }}>
              <strong>Total Approved Hours: {totalApprovedHours.toFixed(1)}</strong>
            </p>
          </>
        ) : (
          <p style={{ fontStyle: 'italic', color: '#666' }}>No time logs recorded</p>
        )}
      </div>
    );
  };

  return (
    <div>
      <div style={{ marginBottom: '20px' }}>
        <p>
          <strong>Total Completed Hours: {calculateTotalApprovedHours(studentTimeLogs)}</strong>
        </p>
      </div>

      {studentOpportunities.length > 0 ? (
        <div>
          {studentOpportunities.map((opportunity) =>
            renderOpportunityTimeLogs(opportunity)
          )}
        </div>
      ) : (
        <p style={{ fontStyle: 'italic', color: '#666' }}>No opportunities available.</p>
      )}
    </div>
  );
};

export default StudentTimeLogsDetailsPdf;
